import { Outlet } from 'react-router-dom';

const Designs = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Designs;
